<div
  class="h-full md:max-h-screen bg-cover bg-top md:bg-center"
  [style.background-image]="backgroundUrl"
></div>
